import { BaseResponseInterface } from '@interface/public';
import { AxiosAPI } from '@server/_axios';

const apiPath = { // API地址
  user: 'sso/api/v1/user/' // 用户
};

//----- 刷新凭证 Start -----//
export interface RequestSSORefresh {
}

export interface ResponseSSORefresh extends BaseResponseInterface {
  data: {
    token: string; // 会话
  }
}

export async function AxiosSSORefresh(data: RequestSSORefresh): Promise<any> {
  return AxiosAPI({
    url: `${ apiPath.user }refresh`,
    method: 'put',
    data
  });
}

//----- 刷新凭证 End -----//